// The referral program: the "invited you" bar, and the line on sign-up, the
// paywall and /pricing, for visitors who arrived on a creator's ?ref= link
// (apps/web/components/referral/InvitedBar, InvitedLine). See
// messages/README.md.
// "Voice Pass" follows nav.profile.voicePass in each language.
export const referral = {
  en: {
    "referral.bar.title": "{name} invited you",
    "referral.bar.detail": "Subscribe and get a free Voice Pass.",
    "referral.bar.cta": "Free Voice Pass",
    "referral.bar.hide": "Hide",
    "referral.line.title": "{name} invited you",
    "referral.line.detail": "Your free Voice Pass comes with your plan.",
  },
};
